import React from 'react';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import { GetInternalLinkFunctionType } from '@rsc/models/GetInternalLinkFunctionType';
import { SanityBlockBuilderLinkGrid } from '@rsc/models/gatsby-graphql-types';
import { UnionToIntersection } from '@rsc/models/utilityTypes';
import YoutubeVideo from '../../../YoutubeVideo';

const Frame = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  background: gray;
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.05);

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  > * {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export type BlockBuilderLinkGridCardProps = {
  // need UnionToIntersection because auto type generation does not type discriminate on _type
  item: UnionToIntersection<SanityBlockBuilderLinkGrid['items'][number]>;
  getInternalLink?: GetInternalLinkFunctionType;
};

function BlockBuilderLinkGridCard({
  item,
  getInternalLink = () => '#',
}: Readonly<BlockBuilderLinkGridCardProps>) {
  // eslint-disable-next-line no-underscore-dangle
  if (item._type === 'video') {
    return <YoutubeVideo id={item.id} title={item.caption} />;
  }

  return (
    <LocalizedLink
      className="p-4 bg-card text-card-foreground no-underline hover:underline flex flex-col w-full button-case"
      to={getInternalLink({ reference: item })}
    >
      {item.image?.asset ? (
        <Frame>
          <SanityImage
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...item.image}
            asset={item.image.asset}
            width={450}
            height={450}
            alt="" // No alt because redundant and confusing for screen readers
          />
        </Frame>
      ) : (
        item.store?.previewImageUrl && (
          <Frame>
            <img
              src={item.store?.previewImageUrl}
              width="450"
              alt="" // No alt because redundant and confusing for screen readers
            />
          </Frame>
        )
      )}
      <span>{item?.title || item?.store?.title}</span>
    </LocalizedLink>
  );
}

export default BlockBuilderLinkGridCard;
